import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eb2edf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-container" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "header-content cq-flex-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "system-name" }, "上市孵化器办文系统", -1))
const _hoisted_5 = { class: "operation-box cq-flex-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-zhuye" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "站点主页", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-set" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "设置", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-qingchushujuku" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "清理缓存", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "option-item cq-flex-center" }
const _hoisted_16 = { class: "avatar-box" }
const _hoisted_17 = { class: "username cq-ellipsis-line1" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("修改密码")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-guanbi" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 安全退出 ")
const _hoisted_21 = { class: "menu-container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-caidan" }, null, -1))
const _hoisted_23 = { class: "menu-item-name" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-caidan" }, null, -1))
const _hoisted_25 = { class: "menu-item-name" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-caidan" }, null, -1))
const _hoisted_27 = { class: "menu-item-name" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-caidan" }, null, -1))
const _hoisted_29 = { class: "menu-item-name" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-set" }, null, -1))
const _hoisted_31 = { class: "menu-item-name" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-set" }, null, -1))
const _hoisted_33 = { class: "menu-item-name" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-set" }, null, -1))
const _hoisted_35 = { class: "menu-item-name" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-set" }, null, -1))
const _hoisted_37 = { class: "menu-item-name" }
const _hoisted_38 = { class: "main-view-container" }
const _hoisted_39 = {
  key: 0,
  class: "icon iconfont icon-jiantou_xiangyouliangci"
}
const _hoisted_40 = {
  key: 1,
  class: "icon iconfont icon-jiantou_xiangzuoliangci"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "option-item cq-flex-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toP2ipoWeb()))
          }, _hoisted_8),
          (_ctx.userData.roleId == 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "option-item cq-flex-center",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSeetingClick()))
              }, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "option-item cq-flex-center",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clear()))
          }, _hoisted_14),
          _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: _ctx.handleCommandClick
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { command: "welcome" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userData.nickname ? _ctx.userData.nickname : 'username'), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.userData.roleId != 1)
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 0,
                        command: "changePwd"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                    default: _withCtx(() => [
                      _hoisted_19,
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_avatar, {
                    size: 30,
                    src: _ctx.userData.avatar ? _ctx.userData.avatar : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.userData.nickname ? _ctx.userData.nickname : 'username'), 1)
              ])
            ]),
            _: 1
          }, 8, ["onCommand"])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["content-container", {smallwidth: _ctx.isMenuCollapse}])
    }, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_el_menu, {
          class: "el-menu-vertical-demo",
          "text-color": "#002D5B",
          "active-text-color": "#fff",
          collapse: _ctx.isMenuCollapse,
          "unique-opened": true,
          onSelect: _ctx.handleMenuSelect,
          "default-active": _ctx.menuActive,
          "default-openeds": _ctx.menuOpened
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (menuOne, o) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: o }, [
                (menuOne.children && menuOne.children.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                      key: 0,
                      index: menuOne.action ? menuOne.action : `${o}`
                    }, {
                      title: _withCtx(() => [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(menuOne.name), 1)
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuOne.children, (menuTwo, tw) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: tw }, [
                            (menuTwo.children && menuTwo.children.length > 0)
                              ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                  key: 0,
                                  index: menuTwo.action ? menuTwo.action : `${o}-${tw}`
                                }, {
                                  title: _withCtx(() => [
                                    _hoisted_24,
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(menuTwo.name), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuTwo.children, (menuThree, th) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: th }, [
                                        (menuThree.children && menuThree.children.length > 0)
                                          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                              key: 0,
                                              index: menuThree.action ? menuThree.action : `${o}-${tw}-${th}`
                                            }, {
                                              title: _withCtx(() => [
                                                _hoisted_26,
                                                _createElementVNode("span", _hoisted_27, _toDisplayString(menuThree.name), 1)
                                              ]),
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuThree.children, (menuFour, fo) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, { key: fo }, [
                                                    (menuFour.children && menuFour.children.length > 0)
                                                      ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                                          key: 0,
                                                          index: menuFour.action ? menuFour.action : `${o}-${tw}-${th}-${fo}`
                                                        }, {
                                                          title: _withCtx(() => [
                                                            _hoisted_28,
                                                            _createElementVNode("span", _hoisted_29, _toDisplayString(menuFour.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["index"]))
                                                      : (_openBlock(), _createBlock(_component_el_menu_item, {
                                                          key: 1,
                                                          index: menuFour.action ? menuFour.action : `${o}-${tw}-${th}-${fo}`
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_30,
                                                            _createElementVNode("span", _hoisted_31, _toDisplayString(menuFour.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["index"]))
                                                  ], 64))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["index"]))
                                          : (_openBlock(), _createBlock(_component_el_menu_item, {
                                              key: 1,
                                              index: menuThree.action ? menuThree.action : `${o}-${tw}-${th}`
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_32,
                                                _createElementVNode("span", _hoisted_33, _toDisplayString(menuThree.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["index"]))
                                      ], 64))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["index"]))
                              : (_openBlock(), _createBlock(_component_el_menu_item, {
                                  key: 1,
                                  index: menuTwo.action ? menuTwo.action : `${o}-${tw}`
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_34,
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(menuTwo.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["index"]))
                          ], 64))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  : (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 1,
                      index: menuOne.action ? menuOne.action : `${o}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36,
                        _createElementVNode("span", _hoisted_37, _toDisplayString(menuOne.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["collapse", "onSelect", "default-active", "default-openeds"])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_router_view)
      ])
    ], 2),
    _createElementVNode("div", {
      class: "menu-collapse",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMenuCollapse = !_ctx.isMenuCollapse))
    }, [
      (_ctx.isMenuCollapse)
        ? (_openBlock(), _createElementBlock("i", _hoisted_39))
        : (_openBlock(), _createElementBlock("i", _hoisted_40))
    ])
  ]))
}